module.exports = __webpack_public_path__ + "img/4.c1f553e2.jpg";